import { render, staticRenderFns } from "./WritingtypeDetails.vue?vue&type=template&id=4412a164&"
import script from "./WritingtypeDetails.vue?vue&type=script&lang=js&"
export * from "./WritingtypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports